/* AUTAVEX — накидки: кольори екошкіри (узор один) */
window.AV_NK_ECO=[
 ['\u0411\u0435\u0436\u0435\u0432\u0438\u0439','#CDB595','IMG-3975.jpg?v=1786526127'],
 ['\u0421\u0432\u0456\u0442\u043b\u043e-\u043a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#A07850','IMG-3981.jpg?v=1786526126'],
 ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#6B4A33','IMG-3980.jpg?v=1786526127'],
 ['\u0428\u043e\u043a\u043e\u043b\u0430\u0434\u043d\u0438\u0439','#4A3327','IMG-3969.jpg?v=1786526127'],
 ['\u0421\u0456\u0440\u0438\u0439','#7E8388','IMG-3979.jpg?v=1786526126'],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0438\u0439','#4C5053','IMG-3973.jpg?v=1786526127'],
 ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0438\u043d\u0456\u0439','#1E2C48','IMG-3971.jpg?v=1786526127'],
 ['\u0427\u0435\u0440\u0432\u043e\u043d\u0438\u0439','#A8232B','IMG-3978.jpg?v=1786526127'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439','#1F2123','IMG-3977.jpg?v=1786526126'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0456\u043b\u0438\u043c','#2B2D2F','IMG-3974.jpg?v=1786526127'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u043a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u043c','#33261E','IMG-3983.jpg?v=1786526350'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0441\u0438\u043d\u0456\u043c','#20293A','IMG-3982.jpg?v=1786526126'],
 ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u043c','#3A1D20','IMG-3976.jpg?v=1786526127']
];
/* додаткові фото (задні накидки) — у галерею без кружечка */
window.AV_NK_ECO_EXTRA=[
 'IMG-3992.jpg?v=1786526615','IMG-3991.jpg?v=1786526615','IMG-3990.jpg?v=1786526615',
 'IMG-3989.jpg?v=1786526615','IMG-3988.jpg?v=1786526615','IMG-3987.jpg?v=1786526615',
 'IMG-3986.jpg?v=1786526615'
];
